<template>
    <svg viewBox="0 0 9 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M8.78627 8.53115L1.66904 15.7797C1.38508 16.0734 0.925904 16.0734 0.64194 15.7797L0.212973 15.3361C-0.070991 15.0424 -0.070991 14.5675 0.212973 14.2738L6.39372 8L0.219015 1.72623C-0.0649492 1.43253 -0.0649492 0.957625 0.219015 0.663933L0.647981 0.220269C0.931945 -0.0734232 1.39112 -0.0734232 1.67508 0.220269L8.79231 7.46885C9.07023 7.76255 9.07023 8.23745 8.78627 8.53115Z"
            fill="currentColor"
        />
    </svg>
</template>

<script>
export default {
    name: "ChevronRightIcon",
};
</script>
